import config from 'util/site_config';

// Get sentiment mappings from Rails Mention model via site_config
const sentimentEntries = () => Object.entries(config.sentimentMappings).sort((a, b) => a[0] - b[0]); // Sort by score to ensure consistent order

const sentimentNames = () => sentimentEntries().map(([_score, name]) => name);

function getNameForScore(score) {
  const scoreName = config.sentimentMappings[score];
  if (!scoreName) throw new Error(`Unexpected sentiment score: "${score}"`);
  return scoreName;
}

function getScoreForName(scoreName) {
  const score = Object.keys(config.sentimentMappings).find(
    (score) => config.sentimentMappings[score].toLowerCase() === scoreName.toLowerCase()
  );
  if (!score) throw new Error(`Unexpected sentiment: "${scoreName}"`);
  return score;
}

export { sentimentEntries, sentimentNames, getNameForScore, getScoreForName };
